import { render } from "./PasswordChange.vue?vue&type=template&id=50966818&scoped=true"
import script from "./PasswordChange.vue?vue&type=script&lang=js"
export * from "./PasswordChange.vue?vue&type=script&lang=js"

import "./PasswordChange.vue?vue&type=style&index=0&id=50966818&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50966818"

export default script